import { VendorDetails as VendorDetailsForm } from './Form/VendorDetails'
import {
  VendorDetailsAbilityProvider,
  VendorDetailsContextProvider
} from './Providers'

export const VendorInfo = ({ businessDetails }) => {
  return (
    <VendorDetailsAbilityProvider>
      <VendorDetailsContextProvider>
        <VendorDetailsForm businessDetails={businessDetails} />
      </VendorDetailsContextProvider>
    </VendorDetailsAbilityProvider>
  )
}
